import { IConfig } from './libs/interfaces/interfaces';
import { EnvironmentSchema } from './libs/types/types';

class AppConfig implements IConfig {
  public ENV: EnvironmentSchema;

  public constructor() {
    this.ENV = this.envSchema;
  }

  private get envSchema(): EnvironmentSchema {
    return {
      APP: {
        ENVIRONMENT: import.meta.env.VITE_APP_ENV,
        SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
      },
      API: {
        EVERBEAT_BASE_URL: import.meta.env.VITE_APP_BACKEND_URL,
      },
      AWS: {
        REGION: import.meta.env.VITE_APP_AWS_REGION,
        S3: {
          HOLTER_BUCKET: import.meta.env.VITE_APP_S3_HOLTER_BUCKET,
          HOLTER_KEY: import.meta.env.VITE_APP_HOLTER_S3_ACCESS_KEY,
          HOLTER_KEY_ID: import.meta.env.VITE_APP_HOLTER_S3_ACCESS_KEY_ID,
        },
      },
    };
  }
}

export { AppConfig };
